import upperFirst from 'lodash/upperFirst';
import { memo } from 'react';

import type { Appointment } from '@front/common/src/types/commons';
import { getAppointmentsSortedByDay } from '@front/common/src/utils/appointment';
import { FORMATS, formatDate } from '@front/common/src/utils/date';

import { translate } from '@front/i18n';

import Text from '@front/web-ui/src/components/base-text/variants/text';

import { Day, DaysList, Slots } from '../../../common/common';
import Slot from '../../../common/sections/appointments/slot';

const t = translate('basket');

type AppointmentDetailsProps = {
  appointment: Appointment;
};

const AppointmentDetails = ({ appointment: { primary, secondary } }: AppointmentDetailsProps) =>
  secondary.length === 0 ? (
    <Text>{t('.secondary_appointment.zero')}</Text>
  ) : (
    <DaysList>
      {getAppointmentsSortedByDay(primary, secondary).map(({ day, slots }) => (
        <Day key={day.toISOString()}>
          <Text.MDBold>{upperFirst(formatDate(day, FORMATS.DATE.WEEKDAY_DAY_MONTH))}</Text.MDBold>
          <Slots>
            {slots.map(({ text, isPrimary, label }) => (
              <Slot key={text} text={text} isPrimary={isPrimary} label={label} />
            ))}
          </Slots>
        </Day>
      ))}
    </DaysList>
  );

export default memo(AppointmentDetails);
